<div class="container-fluid min-vh-100 bg-light d-flex align-items-center justify-content-center py-3 px-2">
  
  <!-- Loading Card -->
  <div *ngIf="cargando" class="text-center p-5 bg-white rounded shadow-sm border border-secondary-subtle animate__fadeIn" style="max-width: 500px; width: 100%;">
    <div class="spinner-border text-primary mb-3" role="status"></div>
    <h5 class="fw-bold text-secondary font-monospace">VERIFICANDO EXPEDIENTE SEGURO...</h5>
  </div>

  <!-- Error Card (Token Inválido) -->
  <div *ngIf="!cargando && !cotizacion && !procesadoExito" class="card shadow-sm border-danger p-4 text-center animate__fadeIn" style="max-width: 500px; width: 100%;">
    <div class="fs-1 text-danger mb-2">⚠️</div>
    <h4 class="fw-bold text-danger font-monospace">ENLACE INEXISTENTE O EXPIRADO</h4>
    <p class="text-muted small">El enlace de aprobación no es válido, ha caducado o fue revocado por la administración del taller.</p>
  </div>

  <!-- Success Card (Flujo Concluido) -->
  <div *ngIf="!cargando && procesadoExito" class="card shadow-sm border-0 p-4 text-center bg-white animate__fadeIn" style="max-width: 550px; width: 100%;">
    <div class="fs-1 mb-2">🏁</div>
    <h4 class="fw-bold text-dark font-monospace">PROCESO CONCLUIDO</h4>
    <div class="alert bg-light border text-start mt-3 mb-0 text-secondary fw-semibold font-monospace" style="font-size: 0.85rem;">
      {{ estatusFinalMsg }}
    </div>
  </div>

  <!-- Main Card (Formulario de Aprobación Móvil) -->
  <div *ngIf="!cargando && cotizacion && !procesadoExito" class="card shadow-sm border-0 bg-white animate__fadeIn" style="max-width: 600px; width: 100%; border-radius: 12px; overflow: hidden;">
    
    <div class="bg-dark p-4 text-white text-center border-bottom border-secondary">
      <h4 class="mb-1 fw-bold font-monospace">AUTORIZACIÓN DE PRESUPUESTO</h4>
      <span class="badge bg-light text-dark font-monospace fs-6">Folio: {{ cotizacion.folioCotizacion }}</span>
    </div>

    <div class="card-body p-3 p-md-4">
      <p class="text-muted small">Estimado cliente, <strong>{{ cotizacion.nombreCliente || 'CLIENTE COMPAÑÍA' }}</strong>. A continuación detallamos los conceptos evaluados en la rampa de servicio para su vehículo <strong class="text-dark">{{ cotizacion.submarcaVehiculo }} ({{ cotizacion.placasVehiculo }})</strong>:</p>
      
      <!-- 🚗 CROQUIS VEHICULAR RESPONSIVO INTERACTIVO (MODALIDAD A) -->
      <div class="card shadow-sm border-secondary-subtle mb-4">
        <div class="card-header bg-light text-dark font-monospace fw-bold border-bottom small py-2">
          🚗 MAPA DE DAÑOS REGISTRADOS (CONFORMIDAD EN PATIO)
        </div>
        <div class="card-body bg-white d-flex justify-content-center p-2 py-3 overflow-auto">
          
          <div class="croquis-canvas-container" style="position: relative; display: inline-block;">
            <img [src]="currentVehicleSvg" alt="Silueta Vehicular" class="croquis-vehicle-img" style="max-width: 100%; height: auto; display: block;">
            
            <div *ngFor="let pin of datosCarroceriaPatio" 
                 class="croquis-pin"
                 [style.left.%]="pin.x_percentage || pin.xPercentage"
                 [style.top.%]="pin.y_percentage || pin.yPercentage"
                 [ngClass]="{
                   'rayon': (pin.tipo_dano || pin.tipoDano) === 'RAYON',
                   'golpe': (pin.tipo_dano || pin.tipoDano) === 'GOLPE',
                   'rotura': (pin.tipo_dano || pin.tipoDano) === 'ROTURA',
                   'oxido': (pin.tipo_dano || pin.tipoDano) === 'OXIDO',
                   'picadura': (pin.tipo_dano || pin.tipoDano) === 'PICADURA'
                 }"
                 [title]="(pin.tipo_dano || pin.tipoDano) + ': ' + pin.descripcion">
            </div>
          </div>

        </div>
      </div>

      <!-- Detalle de Partidas con Checkboxes de Decisión Comercial Móvil -->
      <div class="list-group shadow-sm mb-4" style="max-height: 280px; overflow-y: auto;">
        <!-- Iteración de líneas del presupuesto -->
        <div *ngFor="let l of cotizacion.lineas; let i = index" class="list-group-item p-3 bg-white border-secondary-subtle">
          <div class="d-flex align-items-start">
            
            <!-- 🚀 INTERCEPTOR TÁCTIL: Casilla de verificación para el cliente -->
            <div class="form-check me-3 mt-1">
              <input class="form-check-input" type="checkbox" 
                     style="width: 22px; height: 22px; cursor: pointer;"
                     [(ngModel)]="l.aprobadoPorCliente" 
                     (change)="recalcularTotalesRemotos()"
                     id="chk-partida-{{i}}">
            </div>

            <div class="flex-grow-1" style="max-width: 65%;">
              <label for="chk-partida-{{i}}" class="form-label mb-0 p-0" style="cursor: pointer; display: block;">
                <span class="badge font-monospace mb-1"
                      [ngStyle]="{
                        'background-color': l.tipoItem === 'Mano de Obra' ? '#e7f1ff' : (l.tipoItem === 'Refaccion' ? '#198754' : '#ffc107'),
                        'color': l.tipoItem === 'Mano de Obra' ? '#0a58ca' : (l.tipoItem === 'Refaccion' ? '#ffffff' : '#664d03')
                      }" style="font-size: 0.68rem; font-weight: bold;">
                  {{ l.tipoItem | uppercase }}
                </span>
                <h6 class="mb-0 fw-bold text-dark small text-uppercase" [style.text-decoration]="l.aprobadoPorCliente ? 'none' : 'line-through'">
                  {{ l.descripcion }}
                </h6>
                <small class="text-muted font-monospace d-block">CANT: {{ l.cantidad }} | P.U: {{ l.precioUnitario | currency:'MXN' }}</small>
              </label>
            </div>
            
            <!-- Importe monetario de la línea con tachado condicional si el cliente la rechaza -->
            <span class="fw-bold font-monospace text-end ms-auto small" 
                  [ngClass]="l.aprobadoPorCliente ? 'text-dark' : 'text-danger-emphasis text-decoration-line-through'">
              {{ l.subtotalLinea | currency:'MXN' }}
            </span>

          </div>
        </div>
      </div>

      <!-- Resumen Financiero Contable -->
      <div class="bg-light p-3 rounded border font-monospace mb-4" style="font-size: 0.85rem;">
        <div class="d-flex justify-content-between border-bottom pb-2 text-muted">
          <span>SUBTOTAL NETO:</span>
          <span class="text-dark fw-bold">{{ cotizacion.subtotal | currency:'MXN' }}</span>
        </div>
        <div class="d-flex justify-content-between border-bottom py-2 text-muted">
          <span>IVA TRASLADADO (16%):</span>
          <span class="text-dark fw-bold">{{ cotizacion.iva | currency:'MXN' }}</span>
        </div>
        <div class="d-flex justify-content-between pt-2 fs-5 fw-bold text-primary">
          <span>TOTAL A AUTORIZAR:</span>
          <span>{{ cotizacion.total | currency:'MXN' }}</span>
        </div>
      </div>


      <!-- 🖼️ SECCIÓN INYECTADA: EVIDENCIAS FOTOGRÁFICAS EN SMARTPHONE DEL CLIENTE -->
      <div class="card mb-4 border-0 shadow-sm rounded-3 overflow-hidden bg-white mt-3">
        <div class="card-header bg-light border-0 py-3">
          <h6 class="m-0 fw-bold text-dark">
            📸 Evidencias Fotográficas del Vehículo
          </h6>
          <span class="text-muted small font-monospace" style="font-size: 0.75rem;">
            Fotografías de inspección inicial cargadas por tu asesor técnico en la recepción.
          </span>
        </div>
        
        <div class="card-body p-3">
          @if (data.fotos && data.fotos.length > 0) {
            <div class="row g-2">
              @for (foto of data.fotos; track foto.id; let i = $index) {
                <div class="col-4 col-sm-3">
                  <div class="ratio ratio-4x3 position-relative rounded overflow-hidden border shadow-sm" 
                      style="background-color: #f8f9fa;">
                    <img [src]="foto.urlSanitizada" 
                        class="img-fluid object-fit-cover" 
                        style="cursor: pointer; width: 100%; height: 100%;"
                        (click)="mostrarVisorFotos = true; indiceFotoActual = i"
                        alt="Evidencia Remota">
                  </div>
                  @if (foto.etiqueta) {
                    <div class="text-center text-muted text-truncate mt-1 font-monospace" style="font-size: 0.65rem;">
                      {{ foto.etiqueta | uppercase }}
                    </div>
                  }
                </div>
              }
            </div>
          } @else {
            <!-- Mensaje en caso de que no existan fotos en el pipeline de red -->
            <div class="text-center py-4 text-muted bg-light rounded border border-dashed" style="border-style: dashed !important;">
              <span style="font-size: 1.5rem;">📋</span>
              <p class="small m-0 mt-1 font-monospace">Este expediente no incluye evidencias fotográficas adjuntas.</p>
            </div>
          }
        </div>
      </div>

   
      <!-- Textarea de Observaciones -->
      <div class="mb-4">
        <label class="form-label font-monospace fw-bold small text-secondary text-uppercase">¿Desea agregar alguna nota o comentario?</label>
        <textarea class="form-control text-uppercase" rows="2" [(ngModel)]="comentariosRechazo" style="font-size: 0.85rem;"
                  placeholder="Obligatorio si decide rechazar el presupuesto..."></textarea>
      </div>

      <!-- Botones de Acción Táctiles Responsivos -->
      <div class="row g-3">
        <div class="col-6">
          <button type="button" class="btn btn-outline-danger w-100 py-2.5 fw-bold font-monospace" (click)="responderPresupuesto('RECHAZAR')" style="border-radius: 6px; font-size: 0.85rem;">
            ❌ RECHAZAR
          </button>
        </div>
        <div class="col-6">
          <button type="button" class="btn btn-success w-100 py-2.5 fw-bold font-monospace shadow-sm" (click)="responderPresupuesto('APROBAR')" style="border-radius: 6px; font-size: 0.85rem;">
            ✅ AUTORIZAR
          </button>
        </div>
      </div>

    </div>
  </div>

</div>


<!-- 🖼️ VISOR MODAL A PANTALLA COMPLETA (LIGHTBOX CORREGIDO CON SWIPE Y BOTONES VISIBLES) -->
@if (mostrarVisorFotos && data.fotos && data.fotos.length > 0) {
  <div class="fixed-top w-100 h-100 d-flex flex-column justify-content-center align-items-center bg-dark bg-opacity-95" 
       (touchstart)="onTouchStart($event)"
       (touchend)="onTouchEnd($event)"
       style="z-index: 2000; backdrop-filter: blur(4px); user-select: none; touch-action: none;">
    
    <!-- Botón de Cerrar (Esquina Superior Derecha - Anclado y Visible) -->
    <button type="button" 
            class="btn btn-link text-white position-absolute top-0 end-0 m-3 text-decoration-none fs-2 p-2 fw-bold" 
            (click)="mostrarVisorFotos = false" 
            style="line-height: 1; z-index: 2050; text-shadow: 0 2px 4px rgba(0,0,0,0.5);">
      ✕
    </button>

    <!-- 🚀 BOTÓN ANTERIOR: Anclado rígidamente a la orilla izquierda con color azul eléctrico -->
    @if (indiceFotoActual > 0) {
      <button type="button" 
              class="btn btn-azul-llamativo rounded-circle position-absolute flecha-lightbox-izq d-flex align-items-center justify-content-center shadow-lg"
              (click)="navegarFoto(-1); $event.stopPropagation()">
        ‹
      </button>
    }

    <!-- Contenedor del Cuerpo de la Imagen -->
    <div class="d-flex align-items-center justify-content-center px-2 w-100" style="max-width: 100vw;">
      <div class="text-center">
        <!-- pointer-events: none bloquea que el navegador del celular intente descargar la imagen al arrastrar -->
        <img [src]="data.fotos[indiceFotoActual].urlSanitizada" 
             class="img-fluid rounded-3 shadow-lg border border-secondary" 
             style="max-height: 65vh; max-width: 90vw; object-fit: contain; pointer-events: none;" 
             alt="Evidencia Ampliada">
        
        @if (data.fotos[indiceFotoActual].etiqueta) {
          <div class="d-block mt-2">
            <div class="badge bg-dark border border-secondary text-wrap px-3 py-1.5 font-monospace text-uppercase" style="font-size: 0.75rem; letter-spacing: 0.5px;">
              {{ data.fotos[indiceFotoActual].etiqueta }}
            </div>
          </div>
        }
      </div>
    </div>

    <!-- 🚀 BOTÓN SIGUIENTE: Anclado rígidamente a la orilla derecha con color azul eléctrico -->
    @if (indiceFotoActual < data.fotos.length - 1) {
      <button type="button" 
              class="btn btn-azul-llamativo rounded-circle position-absolute flecha-lightbox-der d-flex align-items-center justify-content-center shadow-lg"
              (click)="navegarFoto(1); $event.stopPropagation()">
        ›
      </button>
    }

    <!-- Indicador de Paginación Inferior -->
    <div class="text-muted small font-monospace mt-3 bg-black bg-opacity-50 px-3 py-1 rounded-pill" style="z-index: 2030;">
      FOTO {{ indiceFotoActual + 1 }} DE {{ data.fotos.length }}
    </div>

  </div>
}